import {base} from '../../../models/base';
import { fromJS } from "immutable";
import _ from 'lodash';

export default {
  namespace: 'search',
  state: {},
  reducers: Object.assign(
    base,
    {
      setData(state, {items, meta}){
        console.info("travel/items", items);
        return { ...state, items: fromJS(items), orig: fromJS(items), tMeta: meta };
      },
      search(state, {items, keyword}){
        console.info("travel/items:" , items);
//        const _items = _.sortBy(items, i => { return parseInt(i.lowest)});
        /*
        const _items = _.sortBy(items, i => {
          console.info(parseInt(i.lowest));
          return i.name;
        });
        */
        const _items = items.sort((a,b) => {
          return parseInt(a.lowest) - parseInt(b.lowest);
        });

//        console.info(_items);
        return { ...state, items: fromJS(items), orig: fromJS(items), searchKeyword: keyword };
      },
      searchKeyword(state, {keyword}){
        console.info("travel/searchKeyword:" , keyword);
        return { ...state, searchKeyword: keyword };
      },
      setSuggestions(state, {items}){
        console.info("travel/suggestions", items);
        return { ...state, suggestions: items };
      },
      toggleList(state){
        const toggle = !state.toggleList;
        return { ...state, toggleList: toggle };
      },
      //-------------------------------------------------------------
      // Filter
      //-------------------------------------------------------------
      /**
       * Filtering price range
       * @param range
       * @returns {{filterPrice: *}}
       */
      filterPrice(state, {range}){
        const _items = state.orig.filter(x => x.get('price') < range[1]);
        console.info("filter price: ", _items.size);
        return { ...state, filterPrice: range, items: _items };
      },
      /**
       * Filtering city
       * @param city
       * @returns {{filterPrice: *}}
       */
      filterCity(state, {value}){
        console.info("filter city: ", value);
        let _items = [];
        if(value == 'all'){
          _items = state.orig;
        }else{
          _items = state.orig.filter(x => x.get('city_key') == value);
        }
        return { ...state, filterCity: value, items: _items };
      },
      //-------------------------------------------------------------
      // Sort
      //-------------------------------------------------------------
      /**
       * Sort Price
       * @param
       * @returns {{filterPrice: *}}
       */
      sortPrice(state){
      //  const _items = state.orig.filter(x => x.get('price') < range[1]);
        let order = state.sortPrice;
        const sortKey = 'lowest';
//        console.info(state);
/*
        const _items = state.orig.sort((a,b) => {
          if(order == 'asc'){
            return a.get('price') > b.get('price');
          }else{
            return a.get('price') <= b.get('price');
          }
        });
*/
        const _items = state.orig.sort((a,b) => {
          if(order == 'asc') {
            return a.get(sortKey) - b.get(sortKey);
          }else {
            return b.get(sortKey) - a.get(sortKey);
          }
        });

        order = (order == 'asc')?'desc':'asc';
        console.info(`sort[${sortKey}]`, order);
        return { ...state, sortPrice: order, items: _items };
      },


      /*
      filterStatus(state, {value}){
        const csItems = (value === 'all')?state.csOrig:state.csOrig.filter(x => x.get('status') === value);
        return { ...state, csItems: csItems, filterStatus: value };
      },
      filterVisa(state, {value}){
        const csItems = (value === 'all')?state.csOrig:state.csOrig.filter(x => x.get('acquired_visa') === value);
        return { ...state, csItems: csItems, filterVisa: value };
      },
      filterSchoolType(state, {value}){
        const csItems = (value === 'all')?state.csOrig:state.csOrig.filter(x => x.get('school_type') === value);
        return { ...state, csItems: csItems, filterVisa: value };
      }
      */
    }
  )
};



// WEBPACK FOOTER //
// ./src/pages/search/models/search.js